import GLightbox from "glightbox";

const lightbox = GLightbox({
  selector: ".wp-lightbox-container",
});
